module.exports = {"510681001":"雒城街道","510681002":"汉州街道","510681003":"金雁街道","510681101":"三水镇","510681102":"连山镇","510681103":"高坪镇","510681105":"向阳镇","510681106":"小汉镇","510681107":"金轮镇","510681114":"金鱼镇","510681116":"南丰镇","510681117":"三星堆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510681.json
// module id = 2427
// module chunks = 0